// QuizManager.js (patched)
import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import "./QuizManager.css";

export default function QuizManager() {
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [newQ, setNewQ] = useState({
    question: "",
    options: ["", "", "", ""],
    correctOption: 0,
  });

  useEffect(() => {
    const loadCategories = async () => {
      const snapshot = await getDocs(collection(db, "questions"));
      setCategories(snapshot.docs.map((d) => d.id));
    };
    loadCategories();
  }, []);

  const loadQuestions = async (category) => {
    setSelected(category);
    const ref = doc(db, "questions", category);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      await setDoc(ref, { questions: [], updatedAt: serverTimestamp() });
      setQuestions([]);
      return;
    }
    const data = snap.data();
    setQuestions(data?.questions || []);
  };

  const handleAdd = async () => {
    if (!selected) return;
    try {
      const updated = [...questions, newQ];
      const ref = doc(db, "questions", selected);
      await setDoc(
        ref,
        { questions: updated, updatedAt: serverTimestamp() },
        { merge: true }
      );
      setQuestions(updated);
      setNewQ({ question: "", options: ["", "", "", ""], correctOption: 0 });
    } catch (e) {
      console.error(e);
      alert("Add failed: " + e.message);
    }
  };

  const handleDelete = async (index) => {
    if (!selected) return;
    try {
      const updated = [...questions];
      updated.splice(index, 1);
      const ref = doc(db, "questions", selected);
      await setDoc(
        ref,
        { questions: updated, updatedAt: serverTimestamp() },
        { merge: true }
      );
      setQuestions(updated);
    } catch (e) {
      console.error(e);
      alert("Delete failed: " + e.message);
    }
  };

  return (
    <div className="quiz-manager">
      <h2>Quiz Manager</h2>

      <div className="category-buttons">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => loadQuestions(cat)}
            className={selected === cat ? "active" : ""}
          >
            {cat}
          </button>
        ))}
      </div>

      {selected && (
        <div className="question-section">
          <h3>{selected} Questions</h3>
          {questions.length === 0 ? (
            <p>No questions yet.</p>
          ) : (
            <ul className="question-list">
              {questions.map((q, i) => (
                <li key={i} className="question-item">
                  <strong>
                    Q{i + 1}: {q.question}
                  </strong>
                  <ul className="option-list">
                    {q.options.map((opt, j) => (
                      <li
                        key={j}
                        className={q.correctOption === j ? "correct" : ""}
                      >
                        {j + 1}. {opt}
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={() => handleDelete(i)}
                    className="delete-btn"
                  >
                    ❌ Delete
                  </button>
                </li>
              ))}
            </ul>
          )}

          <hr />
          <h4>Add New Question</h4>
          <input
            placeholder="Question"
            value={newQ.question}
            onChange={(e) => setNewQ({ ...newQ, question: e.target.value })}
          />
          {newQ.options.map((opt, i) => (
            <input
              key={i}
              placeholder={`Option ${i + 1}`}
              value={opt}
              onChange={(e) => {
                const opts = [...newQ.options];
                opts[i] = e.target.value;
                setNewQ({ ...newQ, options: opts });
              }}
            />
          ))}
          <select
            value={newQ.correctOption}
            onChange={(e) =>
              setNewQ({
                ...newQ,
                correctOption: parseInt(e.target.value, 10),
              })
            }
          >
            <option value={0}>Correct Option: 1</option>
            <option value={1}>Correct Option: 2</option>
            <option value={2}>Correct Option: 3</option>
            <option value={3}>Correct Option: 4</option>
          </select>
          <br />
          <button onClick={handleAdd} className="add-btn">
            ➕ Add Question
          </button>
        </div>
      )}
    </div>
  );
}
